import { Button } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import styles from './InfoModal.module.scss';

interface InfoModalProps {
  content: React.ReactNode;
  onCancel?: () => void;
  onConfirm?: () => void;
  cancelText?: string;
  confirmText: string;
}

const InfoModal = ({ context, id, innerProps }: ContextModalProps<InfoModalProps>) => {
  const handleConfirm = () => {
    innerProps.onConfirm?.();
    context.closeModal(id);
  };

  const handleCancel = () => {
    if (innerProps.onCancel) {
      innerProps.onCancel();
    }
    context.closeModal(id);
  };

  return (
    <>
      <div className={styles.content}>{innerProps.content}</div>
      <div className={styles.buttons}>
        {innerProps.cancelText && innerProps.onCancel && (
          <Button onClick={handleCancel} variant="light">
            {innerProps.cancelText}
          </Button>
        )}
        <Button onClick={handleConfirm}>{innerProps.confirmText}</Button>
      </div>
    </>
  );
};

export default InfoModal;
